// Entry point bundled by esbuild into app/assets/builds/application.js
import Rails from "@rails/ujs";
import Turbolinks from "turbolinks";
import * as ActiveStorage from "@rails/activestorage";
import "./components/TodoApp";
import "./components/PlayerApp";
import "./components/NavBar";

Rails.start();
Turbolinks.start();
ActiveStorage.start();
